export default __webpack_public_path__ + "static/media/img_slide_02.e847c818.jpg";